import { render, staticRenderFns } from "./HeaderLayout.vue?vue&type=template&id=0a3d976d"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./HeaderLayout.vue?vue&type=style&index=0&id=0a3d976d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports